import React, { useState } from "react";

import { ChoiceUI } from "../../UI";
import StudentPracticalExamsTab from "./StudentPracticalExamsTab";
import StudentTheoryExamsTab from "./StudentTheoryExamsTab";

// sub-filele mici, doar cu text (tiparul ChoiceUI look="tabs" size="sm")
const EXAM_TABS = [
   { value: "theory", label: "Teoretic" },
   { value: "practical", label: "Practic" },
];

export default function StudentExamsTab() {
   const [examTab, setExamTab] = useState("theory");

   return (
      <div className="studentsProfileUI__exams">
         <ChoiceUI
            look="tabs"
            size="sm"
            aria-label="Examene"
            value={examTab}
            onChange={setExamTab}
            options={EXAM_TABS}
            className="studentsProfileUI__subTabs"
         />

         {examTab === "theory" ? (
            <StudentTheoryExamsTab />
         ) : (
            <StudentPracticalExamsTab />
         )}
      </div>
   );
}
